export default __webpack_public_path__ + "static/2246-f25d99ebe93851ecc98b7100325faa6d.gif";